import React, { useEffect, useState } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import { apiErrorMessage } from '../../services/notify';
import CadastroEventoImportarMalhaAereo from './CadastroEventoImportarMalhaAereo';
import '../../css/financeiro-parcela-pagar.css';

/**
 * A sugestão de voos do evento (`/cadastroEventoSugestaoAereo/:idEvento`): a tela da malha no modo sugestão. Uma por
 * evento: o back devolve a que existe e, para o Aéreo que atende o evento, cria a primeira
 * (`EventoAereoAprovacaoService::abrirSugestao`). Os outros cargos, sem sugestão, veem o aviso.
 */
export default function CadastroEventoSugestaoAereo({ match }) {
    const idEvento = match.params.idEvento;
    const token = localStorage.getItem('token');
    const [estado, setEstado] = useState({ carregando: true, malha: null, erro: null });

    useEffect(() => {
        let vivo = true;
        api({ method: 'post', action: '/eventoMalhaAereaSugestao', token, data: { evento: idEvento } })
            .then(res => {
                if (res.data?.status === false) throw { response: res };
                if (vivo) setEstado({ carregando: false, malha: res.data?.data?.malha ?? null, erro: null });
            })
            .catch(err => {
                if (vivo) setEstado({ carregando: false, malha: null, erro: apiErrorMessage(err, 'Não foi possível abrir a sugestão de voos.') });
            });
        return () => { vivo = false; };
    }, [idEvento, token]);

    if (estado.malha) {
        return <CadastroEventoImportarMalhaAereo key={estado.malha} match={{ params: { idMalha: estado.malha } }} sugestao={{ idEvento }} />;
    }
    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                {estado.carregando ? (
                    <div className="d-flex align-items-center justify-content-center gap-2 py-5" style={{ color: 'var(--fin-mt)' }}>
                        <span className="spinner-border spinner-border-sm" role="status" />
                        Abrindo a sugestão de voos...
                    </div>
                ) : (
                    <div className="fin-pp__banner is-warn">
                        <FaExclamationTriangle className="fin-pp__banner-ic" size={14} />
                        <span>{estado.erro ?? 'O Aéreo ainda não subiu sugestão de voos para este evento.'}</span>
                    </div>
                )}
            </div>
        </ErpTemplate>
    );
}
